import {
  IRecognitionCreateProps,
  IRecognitionProps,
  IRecognitionSimpleProps,
  IRecognitionUpdateProps,
} from '../types';
import { IIntegrationProps } from '../../IntegrationService/types';

export interface ICustomerRecognitionProps extends IRecognitionProps {
  birthDate: Date;
  occupation: string;
  email: string;
  age: string;
  gender: CustomerGenderTypes;
  integrations: IIntegrationProps[];
}

export interface ICustomerRecognitionSimpleProps
  extends IRecognitionSimpleProps {
  birthDate: Date;
  age: string;
  gender: CustomerGenderTypes;
}

export interface ICustomerRecognitionCreateProps
  extends IRecognitionCreateProps {
  birthDate: string;
  occupation?: string;
  email?: string;
  age: string;
  gender: string;
}

export interface ICustomerRecognitionUpdateProps
  extends IRecognitionUpdateProps {
  birthDate: string;
  occupation?: string;
  email?: string;
  age: string;
  gender: string;
}

export interface ICustomerRecognitionUpdateParams {
  id: number;
  data: ICustomerRecognitionUpdateProps;
}

export enum CustomerGenderTypes {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}
